import { Link, useLocation } from 'react-router-dom'

import { IconButton } from '@loadsmart/loadsmart-ui'

import { Icon } from 'core/ui/components/icon/Icon'

import user from 'legacy/utils/user'

import { getRfpListBackPath } from './RfpRoute'

export function RfpListBackButton() {
  const { pathname } = useLocation()
  const backPath = getRfpListBackPath(pathname, user.isLoggedIn())

  if (!backPath) {
    return null
  }

  return (
    // @ts-expect-error loadsmart-ui's IconButton types omit the `as` prop it forwards, which renders it as a Link
    <IconButton as={Link} to={backPath} scale={'small'}>
      <Icon name="arrow-left" />
    </IconButton>
  )
}
